// import React, { useEffect, useState } from "react";
// import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
// import Alert from "../../../Common/Alert";
// import DatatableFunc from "../../../Common/DatatableFunc";
// import Http from "../../../Common/Http";
// import { LoaderComponent } from "../../../Common/LoaderComponent";
// import IsLogin from "../../../Common/IsLogin";

// const Show = () => {
//   const [receiveData, setReceiveData] = useState([]);
//   const { id } = useParams();
//   const [alert, setAlert] = useState(null);
//   const location = useLocation();

//   const fetchData = () => {
//     Http.get("/issue/" + id).then((res) => {
//       setReceiveData(res.data.info);
//     });
//   };

//   useEffect(() => {
//     DatatableFunc();
//     fetchData();
//   }, []);

//   const showAlert = (message, type) => {
//     setAlert({
//       message: message,
//       type: type,
//     });
//     setTimeout(() => {
//       setAlert(null);
//     }, 4000);
//   };

//   useEffect(() => {
//     if (!location.state) {
//       return;
//     }
//     showAlert(location.state.message, location.state.type);
//   }, [location]);

//   return (
//     <div>
//       <IsLogin></IsLogin>
//       <LoaderComponent />
//       <div>
//         <div className="am-mainpanel">
//           <div className="am-pagetitle">
//             <h5 className="am-title">Issue Production</h5>
//           </div>

//           <div className="am-pagebody">
//             <Alert alert={alert} />
//             <div className="card pd-20 pd-sm-40">
//               <div className="col-lg-12 col-md-12 col-sm-12 col-12 padding">
//                 <div className="card">
//                   <div className="card-body">
//                     <div className="row mb-4">
//                       <div className="col-sm-12">
//                         <h5 className="mb-3">Issue Production:</h5>
//                         <div>Reference No : {receiveData.reference_no}</div>
//                         <div>Date : {receiveData.date}</div>
//                         <div>Time : {receiveData.time}</div>
//                         <div>
//                           Department :
//                           {receiveData.department
//                             ? receiveData.department.name
//                             : ""}
//                         </div>
//                         {receiveData.product ? (
//                           <div>
//                             Finished Good :
//                             {receiveData.product
//                               ? receiveData.product.name
//                               : ""}
//                           </div>
//                         ) : (
//                           ""
//                         )}
//                         {receiveData.batch_no ? (
//                           <div>Batch No : {receiveData.batch_no}</div>
//                         ) : (
//                           ""
//                         )}
//                         {receiveData.batch_size ? (
//                           <div>Batch Size : {receiveData.batch_size}</div>
//                         ) : (
//                           ""
//                         )}
//                         {receiveData.receipe_type ? (
//                           <div>Receipe Type : {receiveData.receipe_type}</div>
//                         ) : (
//                           ""
//                         )}
//                         <div>
//                           Created By :
//                           {receiveData.created_by
//                             ? receiveData.created_by.name
//                             : ""}
//                         </div>
//                       </div>
//                     </div>
//                     <div className="table-responsive-sm">
//                       <table className="table table-striped">
//                         <thead>
//                           <tr>
//                             <th className="center">#</th>
//                             <th>Product</th>
//                             <th className="text-right">Stndrd Qty</th>
//                             <th className="text-right">Issue Qty</th>
//                             <th className="text-right">Detail</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {receiveData.items
//                             ? receiveData.items.map((item, index) => (
//                                 <tr key={item.id}>
//                                   <td className="center">{index + 1}</td>
//                                   <td className="left strong">
//                                     {item.product ? item.product.name : ""}
//                                   </td>
//                                   <td className="text-right">
//                                     {item.stndrd_qty}
//                                   </td>
//                                   <td className="text-right">{item.qty}</td>
//                                   <td className="text-right">
//                                     {item.detail
//                                       ? item.detail.map(
//                                           (value, key) =>
//                                             "(" +
//                                             value.qty +
//                                             " X " +
//                                             (value.grn
//                                               ? value.grn.unit_price
//                                               : 0) +
//                                             ")" +
//                                             "=" +
//                                             value.qty *
//                                               (value.grn
//                                                 ? value.grn.unit_price
//                                                 : 0) +
//                                             " | "
//                                         )
//                                       : ""}
//                                   </td>
//                                 </tr>
//                               ))
//                             : ""}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Show;

import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import IsLogin from "../../../Common/IsLogin";

const Show = () => {
  const [receiveData, setReceiveData] = useState([]);
  const { id } = useParams();
  const [alert, setAlert] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const fetchData = () => {
    Http.get("/issue/" + id).then((res) => {
      setReceiveData(res.data.info);
    });
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Issue Production Details</h5>
          {/* <div className="am-breadcrumb">
            <span>
              <Link to="/">Home</Link>
            </span>
            <span>
              <Link to="/issue">Issue Production</Link>
            </span>
            <span className="active">View Details</span>
          </div> */}
        </div>

        <div className="am-pagebody">
          <Alert alert={alert} />

          <div className="card pd-20 pd-sm-40">
            <div className="card-header bg-gray-200 pd-y-20 d-flex align-items-center justify-content-between">
              <h6 className="tx-uppercase tx-bold tx-spacing-1 mg-b-0">
                Issue Production Information
              </h6>
              <div>
                <Link to="/direct-issue" className="btn btn-secondary btn-sm">
                  <i className="icon ion-arrow-left-c"></i> Back to List
                </Link>
              </div>
            </div>

            <div className="card-body pd-30">
              {/* Basic Information Section */}
              <div className="row mg-b-30">
                <div className="col-lg-12">
                  <div className="section-wrapper pd-20 bd bd-gray-300 rounded">
                    <label className="section-title tx-uppercase tx-bold tx-spacing-1 tx-12 tx-gray-600 mg-b-20">
                      Basic Details
                    </label>
                    <div className="row">
                      <div className="col-md-6 col-lg-4 mg-t-10">
                        <div className="info-group">
                          <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 tx-gray-600">
                            Reference No
                          </label>
                          <p className="tx-14 tx-semibold tx-gray-800 mg-b-0">
                            {receiveData.reference_no || "N/A"}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-4 mg-t-10">
                        <div className="info-group">
                          <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 tx-gray-600">
                            Date
                          </label>
                          <p className="tx-14 tx-semibold tx-gray-800 mg-b-0">
                            {receiveData.date || "N/A"}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-4 mg-t-10">
                        <div className="info-group">
                          <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 tx-gray-600">
                            Time
                          </label>
                          <p className="tx-14 tx-semibold tx-gray-800 mg-b-0">
                            {receiveData.time || "N/A"}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-4 mg-t-20">
                        <div className="info-group">
                          <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 tx-gray-600">
                            Department
                          </label>
                          <p className="tx-14 tx-semibold tx-gray-800 mg-b-0">
                            {receiveData.department?.name || "N/A"}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-4 mg-t-20">
                        <div className="info-group">
                          <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 tx-gray-600">
                            Created By
                          </label>
                          <p className="tx-14 tx-semibold tx-gray-800 mg-b-0">
                            {receiveData.created_by?.name || "N/A"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Production Details Section */}
              {(receiveData.product ||
                receiveData.batch_no ||
                receiveData.batch_size ||
                receiveData.receipe_type) && (
                <div className="row mg-b-30">
                  <div className="col-lg-12">
                    <div className="section-wrapper pd-20 bd bd-gray-300 rounded bg-gray-50">
                      <label className="section-title tx-uppercase tx-bold tx-spacing-1 tx-12 tx-gray-600 mg-b-20">
                        Production Details
                      </label>
                      <div className="row">
                        {receiveData.product && (
                          <div className="col-md-6 col-lg-4 mg-t-10">
                            <div className="info-group">
                              <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 tx-gray-600">
                                Finished Good
                              </label>
                              <p className="tx-14 tx-semibold tx-primary mg-b-0">
                                {receiveData.product.name}
                              </p>
                            </div>
                          </div>
                        )}
                        {receiveData.batch_no && (
                          <div className="col-md-6 col-lg-4 mg-t-10">
                            <div className="info-group">
                              <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 tx-gray-600">
                                Batch No
                              </label>
                              <p className="tx-14 tx-semibold tx-gray-800 mg-b-0">
                                {receiveData.batch_no}
                              </p>
                            </div>
                          </div>
                        )}
                        {receiveData.batch_size && (
                          <div className="col-md-6 col-lg-4 mg-t-10">
                            <div className="info-group">
                              <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 tx-gray-600">
                                Batch Size
                              </label>
                              <p className="tx-14 tx-semibold tx-gray-800 mg-b-0">
                                {receiveData.batch_size}
                              </p>
                            </div>
                          </div>
                        )}
                        {receiveData.receipe_type && (
                          <div className="col-md-6 col-lg-4 mg-t-10">
                            <div className="info-group">
                              <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 tx-gray-600">
                                Recipe Type
                              </label>
                              <p className="tx-14 tx-semibold tx-gray-800 mg-b-0">
                                {receiveData.receipe_type}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Items Table Section */}
              <div className="row">
                <div className="col-lg-12">
                  <div className="section-wrapper">
                    <label className="section-title tx-uppercase tx-bold tx-spacing-1 tx-12 tx-gray-600 mg-b-20">
                      Issued Items
                    </label>
                    <div className="table-responsive">
                      <table className="table table-hover mg-b-0">
                        <thead className="thead-light">
                          <tr>
                            <th className="text-center wd-5p">#</th>
                            <th className="wd-35p">Product</th>
                            <th className="text-right wd-15p">Standard Qty</th>
                            <th className="text-right wd-15p">Issue Qty</th>
                            <th className="text-right wd-30p">Cost Detail</th>
                          </tr>
                        </thead>
                        <tbody>
                          {receiveData.items && receiveData.items.length > 0 ? (
                            receiveData.items.map((item, index) => (
                              <tr key={item.id}>
                                <td className="text-center tx-medium">
                                  {index + 1}
                                </td>
                                <td className="tx-medium tx-gray-800">
                                  {item.product?.name || "N/A"}
                                </td>
                                <td className="text-right tx-medium">
                                  {item.stndrd_qty || "0"}
                                </td>
                                <td className="text-right tx-semibold tx-primary">
                                  {item.qty || "0"}
                                </td>
                                <td className="text-right tx-12">
                                  {item.detail && item.detail.length > 0 ? (
                                    <div className="d-flex flex-wrap justify-content-end">
                                      {item.detail.map((value, key) => (
                                        <span
                                          key={key}
                                          className="badge badge-light mg-r-5 mg-b-5 pd-8"
                                        >
                                          ({value.qty} ×{" "}
                                          {value.grn?.unit_price || 0}) ={" "}
                                          {(
                                            value.qty *
                                            (value.grn?.unit_price || 0)
                                          ).toFixed(2)}
                                        </span>
                                      ))}
                                    </div>
                                  ) : (
                                    <span className="tx-gray-500">
                                      No details
                                    </span>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan="5"
                                className="text-center pd-20 tx-gray-500"
                              >
                                No items found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Show;
